export const CertipersUserStatus = {
  ACTIVE: "ACTIVE",
  UNACTIVE: "UNACTIVE",
  PENDING: "PENDING",
  WAITING_DOCUMENTATION: "WAITING_DOCUMENTATION",
};

export const PROFILE_MAIN_FIELDS = [
  "lastName",
  "firstName",
  "telephoneNumber",
  "mobileTelephoneNumber",
  "mobileTelephoneNumberPro",
  "email",
  "emailPro",
  "adress",
  "postalCode",
  "city",
  "birthDate",
];

export const PROFILE_COMPANY_FIELDS = [
  "companyName",
  "companySiret",
  "companyAdress",
  "companyPostalCode",
  "companyCity",
  "companyPhone",
  "companyEmailPro",
];

export const PROFILE_BILLING_FIELDS = [
  "billingName",
  "billingSiret",
  "billingAdress",
  "billingPostalCode",
  "billingCity",
  "billingEmailPro",
  "billingPhone",
  "billingTvaNumber",
];

export const PROFILE_BOOK_FIELDS = [
  "bookAdress",
  "bookPostalCode",
  "bookCity",
  "bookEmailPro",
  "bookPhone",
];
